module.exports = __webpack_public_path__ + "img/9.42614012.jpg";